// @ts-nocheck
import { useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { EventService } from '../services';

export function useEventService(organizationId: string | null): EventService | null {
  console.log('🔧 useEventService - organizationId:', organizationId);

  return useMemo(() => {
    if (!organizationId) {
      console.warn('⚠️ useEventService - organizationId is null, returning null');
      return null;
    }
    console.log('✅ useEventService - Creating EventService with org:', organizationId);
    return new EventService(supabase, organizationId);
  }, [organizationId]);
}